import React from 'react'
import { Table } from 'antd'
import { defaultPagination } from '../../../../services/api/client/types'
import { CompanyListItem } from '../../../../services/api/companies'
import { companyPath } from '../../../../routes/paths'
import { useHistory } from 'react-router-dom'

type TableProps = {
  data?: CompanyListItem[]
  meta?: any
  isLoading: boolean
  onPaginationChange: (page: number, perPage?: number) => void
}

export const CompaniesTable: React.FunctionComponent<TableProps> = ({
  data,
  meta,
  isLoading,
  onPaginationChange,
}) => {
  const history = useHistory()

  return (
    <Table
      dataSource={data}
      columns={[
        {
          title: 'Название',
          dataIndex: 'name',
        },
        {
          title: 'ИНН',
          dataIndex: 'inn',
        },
        {
          title: 'КПП',
          dataIndex: 'kpp',
        },
        {
          title: 'БИК',
          dataIndex: 'bic',
        },
        {
          title: 'Расчетный счет',
          dataIndex: 'account',
        },
      ]}
      pagination={{
        onChange: onPaginationChange,
        hideOnSinglePage: true,
        current: meta?.page || defaultPagination.page,
        pageSize: meta?.perPage || defaultPagination.perPage,
        total: meta?.totalCount,
        defaultCurrent: defaultPagination.page,
        defaultPageSize: defaultPagination.perPage,
      }}
      loading={isLoading}
      rowKey={(company) => company.id}
      onRow={(company) => {
        return {
          onClick: () => {
            history.push(companyPath(company.id))
          },
        }
      }}
    />
  )
}
